import { getApi} from "../api";


export const viewSubtranctionApi = ()=> getApi(`masters/usersubscription/userplan/${localStorage.getItem('userId')}`)